<div class="stagri mt-3">
  <div
    class="zitem bg-bg1 shadow-sm csw p-4 text-center"
    *ngFor="let st of stats"
  >
    <h4>{{st.name}}</h4>
    <p>{{st.fullname}}</p>
  </div>
</div>
